type AmountValue = string | number | null | undefined

/**
 * Amounts to apply (in order) when an amount picker mounts.
 * An amount already in the form wins, so remounting a step (e.g. "Back") keeps the donor's choice.
 */
export function initialAmountSources(existing: AmountValue, param: AmountValue, defaultAmount: AmountValue): (string | number)[] {
  if (existing) return [existing]
  return [param, defaultAmount].filter((v): v is string | number => !!v)
}
